var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:( _obj = {}, _obj[("footer-" + _vm.type)] = _vm.type, _obj ),attrs:{"data-background-color":_vm.backgroundColor}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n      by "+_vm._s(_vm.storeNow ? _vm.storeNow.name : '賣店')+" 連絡電話: "+_vm._s(_vm.storeNow.customer_service_phone_number)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }